<template>
  <el-card v-loading="loading" shadow="never">
    <slot slot="header"></slot>
    <div ref="chartDom" style="height: 100%" />
  </el-card>
</template>

<script>
let echarts = require('echarts')
let elementResizeDetectorMaker = require("element-resize-detector")
export default {
  data () {
    return {
      loading: false,
      queryParams: this.params,
    }
  },
  props: {
    params: { type: Object, default: null }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    onSearch (p) {
      this.queryParams = { ...this.queryParams, ...p }
      this.loadData()
    },
    loadData () {
      this.loading = true
      this.$apis.trend.category.sales(this.queryParams).then(res => {
        this.drawChart(res)
      }).finally(() => {
        this.loading = false
      })
    },
    drawChart (source) {
      const that = this
      let option = {
        grid: {
          left: 50,
          top: 20,
          right: 20,
          bottom: 20
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          top: 'center',
          left: '50%',
          itemGap: 20,
          formatter: name => {
            var row = source.items.filter(x => x.name == name)[0]

            let arr = [
              '{a|' + row.name + '}',
              '{b|' + row.value + '万}',
              '{b|' + row.count + '笔}',
              '{b|' + row.quantity + '件}'
            ]
            return arr.join('')
          },
          textStyle: {
            rich: {
              a: {
                width: 72,
              },
              b: {
                align: 'right',
                width: 56,
              }
            }
          }
        },
        series: [{
          data: source.items.map(row => { return { name: row.name, value: row.value } }),
          type: 'pie',
          radius: ['75%', '90%'],
          width: '50%',
          minAngle: 15,
          label: {
            show: false,
            position: 'center',

          },
          emphasis: {
            label: {
              show: true,
              formatter: '{a|{b}}\n{b|{d}%}',
              rich: {
                a: {
                  fontSize: 18,
                  align: 'center'
                },
                b: {
                  fontSize: 44,
                  lineHeight: 64,
                  fontWeight: 'bold',
                  color: '#409EFF',
                }
              }
            }
          },
        }]
      }
      const dom = that.$refs['chartDom']
      if (dom) {
        let chart = echarts.getInstanceByDom(dom)
        if (chart == null) {
          chart = echarts.init(dom)
          // 点击事件
          chart.on('click', function (params) {
            that.$router.push({ path: "detail", query: { ...that.params, category: params.name } })
          })
          //响应刷新
          elementResizeDetectorMaker().listenTo(dom, function () {
            chart.resize()
          })
        }
        chart.setOption(option)
      }
    }
  }
}
</script>
